import classNames from 'classnames';
import DotsLoading from '../../../../../components/dotsLoading';

interface SubmitButtonProps {
  isLoading: boolean;
}

const SubmitButton = ({isLoading}: SubmitButtonProps) => (
  <button
    type="submit"
    className={classNames(
      'w-full text-white my-3 h-12 rounded mb-3 bg-farm-shop-500',
      {'opacity-50 cursor-not-allowed': isLoading},
    )}
    disabled={isLoading}
  >
    {isLoading ? <DotsLoading /> : 'ثبت استوری'}
  </button>
);

export default SubmitButton;
